import React from 'react';
import PropTypes from 'prop-types';
import * as S from './P.styles';

const P = ({ align, children, font, type, variant, weight, modifier }) => (
  <S.P
    align={align}
    font={font}
    type={type}
    variant={variant}
    weight={weight}
    modifier={modifier}
    as='p'
  >
    {children}
  </S.P>
);

P.defaultProps = {
  align: 'left',
  font: 'primary',
  type: '1',
  variant: 'primary',
  weight: 'regular',
  modifier: 'regular',
};

P.propTypes = {
  align: PropTypes.oneOf(['center', 'right', 'left']).isRequired,
  font: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  type: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']).isRequired,
  variant: PropTypes.oneOf([
    'primary',
    'secondary-1',
    'secondary-2',
    'secondary-3',
    'neutral',
    'neutral-1',
    'danger',
    'warning',
    'info',
    'success',
  ]).isRequired,
  weight: PropTypes.oneOf(['regular', 'bold']).isRequired,
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted'])
    .isRequired,
};

export default P;
